import React from 'react';
import { Table } from 'react-bootstrap';

const brl = (v) =>
  (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const GridCedentesLimite = ({ dados }) => {
  if (!dados || dados.length === 0) {
    return <p className="text-muted small">Nenhum cedente com limite configurado.</p>;
  }

  return (
    <div className="table-responsive" style={{ maxHeight: 400, overflowY: 'auto' }}>
      <Table striped bordered hover size="sm">
        <thead style={{ backgroundColor: '#0747a6', color: '#fff' }}>
          <tr>
            <th>Cedente</th>
            <th>Apelido</th>
            <th>Limite Crédito</th>
            <th>Limite Sacado</th>
            <th>Total Crédito</th>
            <th>Total Sacado</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((item) => (
            <tr
              key={`${item.cedente}-${item.apelido_conta}`}
              className={item.cor === 1 ? 'table-warning' : ''}
            >
              <td>{item.cedente}</td>
              <td>{item.apelido_conta}</td>
              <td>{brl(item.limite_credito)}</td>
              <td>{brl(item.limite_sacado)}</td>
              <td>{brl(item.total_credito)}</td>
              <td>{brl(item.total_sacado)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default GridCedentesLimite;
